module.exports = __webpack_public_path__ + "img/tu_schedule_meeting_active.9da27083.svg";